import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShapeDiverValue } from '../../shape-diver';

type State = Record<string, ShapeDiverValue>;

type ChangeValuePayload = {
  id: string;
  value: ShapeDiverValue;
};

const valuesSlice = createSlice({
  name: 'options',
  initialState: {} as State,
  reducers: {
    changeValue(state, action: PayloadAction<ChangeValuePayload>) {
      const { id, value } = action.payload;
      state[id] = value;
    },
    changeValues(
      state,
      action: PayloadAction<Record<string, ShapeDiverValue>>
    ) {
      Object.assign(state, action.payload);
    },
  },
});

const { changeValue, changeValues } = valuesSlice.actions;

export { changeValue, changeValues };
export default valuesSlice.reducer;
